$('.featureSlider').slick({
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    swipe: false,
    touchMove: false,
});

$("#TestimonialSliderOne").slick({
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    responsive: [
        {
            breakpoint: 990,
            settings: {
                arrows: false,
            }
        }
    ]
});

    $('.insta-story--slider').slick({
            speed: 8000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 2,
            slidesToScroll: 2,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,   
            mobileFirst: true,    
            responsive: [
                    {
                    breakpoint: 750,
                    lazyLoad: 'progressive',
                    settings: "unslick",
                    }, 
                
                    {
                    breakpoint: 749,
                    settings: {slidesToShow: 2, slidesToScroll: 2,}
                    },
                ],
        }); 

// 
$(".boxVideo__btn").click(function () {
    var video = $(this).parents('.boxVideo').find(".boxVideo__video").get(0);

    video.addEventListener('ended', myHandler, false);
    
    $(this).toggleClass("active");
    if (video.paused === true) {
        video.play();
    } else {
        video.pause();
    }

    function myHandler(e) {
        $(this).parents(".famousVideos__box").find(".boxVideo__btn").removeClass("active");        
    }
});





$(document).on("click", ".toggleRow .trulyAccordian .toggleCols", (function () {

    $(this).parents(".toggleRow").siblings().removeClass("active"),
        $(this).parents(".toggleRow").siblings().find(".trulyAccordian").removeClass("active")
    $(this).parents(".toggleRow").siblings().find(".trulyAccordian__cntnt").slideUp(),

        $(this).parents(".toggleRow").toggleClass("active")
    $(this).parents(".toggleRow").find(".trulyAccordian").toggleClass("active")
    $(this).parents(".toggleRow").find(".trulyAccordian__cntnt").slideToggle(200)

    // $(this).next(".truly_product_dropdown").toggleClass("open"), 
    // $(this).next(".trulyAccordian__cntnt").slideToggle(200)
})
);


$(".triple-accordian ").each(function () {
    if (window.matchMedia('(max-width: 750px)').matches) {
        var divs = $(this).find('.trulyAccordian');
        for (var i = 0; i < divs.length; i += 2) {
            divs.slice(i, i + 2).wrapAll("<div class='AccordianDoubleRow toggleRow'></div>");
        }
    } else {
        var divs = $(this).find('.trulyAccordian');
        for (var i = 0; i < divs.length; i += 3) {
            divs.slice(i, i + 3).wrapAll("<div class='AccordianDoubleRow toggleRow'></div>");
        }
    }
});

$(".AccordianDouble ").each(function () {
        var divs = $(this).find('.trulyAccordian');
        for (var i = 0; i < divs.length; i += 2) {
            divs.slice(i, i + 2).wrapAll("<div class='AccordianDoubleRow toggleRow'></div>");

    }
});



mobileOnlySlider(".mobVideo_Slider", false, true, 750);
mobileOnlySlider(".mobStep_Slider", false, true, 750);
function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);
    var settings = {
        mobileFirst: true,
        dots: $dots,
        arrows: $arrows,
        centerMode: true,
        swipeToSlide: true,
        infinite: true,
        centerPadding: "80px",
        responsive: [
            {
                breakpoint: $breakpoint,
                settings: "unslick"
            }
        ]
    };
    slider.slick(settings);
    $(window).on("resize", function () {
        if ($(window).width() > $breakpoint) {
            return;
        }
        if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
        }
    });
} // Mobile Only Slider




$('.mobVideo_Slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('video').each(function () {
        this.pause(); // Stop playing
    });
});



$(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top) {
        $(".sticky-wrap").addClass('sticky-show'),
            $(".head-order-btn").addClass('sticky-hide-head')
    } else {
        $(".sticky-wrap").removeClass('sticky-show'),
            $(".head-order-btn").removeClass('sticky-hide-head')
    }
});

